export default __webpack_public_path__ + "static/bentoSectionBg2-d0cc5c24df74544365916e910ec8f71d.webp";